import { createRoot } from "react-dom/client";
import { DemoApp } from "./DemoApp";
import "./styles.css";

const container = document.getElementById("root");
if (container) {
	createRoot(container).render(<DemoApp />);
}
